
import { createClient } from '@supabase/supabase-js'

const rawUrl = import.meta.env.VITE_SUPABASE_URL
const rawKey = import.meta.env.VITE_SUPABASE_ANON_KEY

const supabaseUrl = typeof rawUrl === 'string' ? rawUrl.trim() : ''
const supabaseAnonKey = typeof rawKey === 'string' ? rawKey.trim() : ''

if (!supabaseUrl || !supabaseAnonKey) {
    console.error(
        '[Supabase] Missing environment variables. ' +
        'Ensure .env exists, VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set, ' +
        'and the dev server was restarted after editing .env.',
        { url: !!supabaseUrl, key: !!supabaseAnonKey, rawUrl, rawKey }
    )
} else if (import.meta.env.DEV) {
    console.log('[Supabase] Client initializing for', supabaseUrl)
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        storageKey: 'sb-auth-token',
    },
})
